import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CountServiceCostsQuery(
    $filters: [Filter]
    $companyId: ID!
    $usageUnitId: ID!
  ) {
    Me {
      id
      Company(id: $companyId) {
        UsageUnit(id: $usageUnitId) {
          data: countServiceCosts(options: { filters: $filters })
        }
      }
    }
  }
`
